import { z } from "zod";

import { AudioQualityBackendResult } from "@/types/defs/audioQuality/audioQualityCheck";

// Wire format returned by the AI backend (snake_case). Only used at the fetch boundary — the rest of the app consumes the camelCase AudioQualityCheck domain type. pitch_analysis is null when the backend skips analysis entirely (instruments or reverb/echo detected).
const audioQualityCheckWireSpec = z.object({
  instrument_ratio: z.number(),
  reverb_ratio: z.number(),
  pitch_analysis: z
    .object({
      user_range_midi: z.object({
        low: z.number(),
        high: z.number(),
      }),
      semitone_shift: z.number(),
    })
    .nullable(),
});

// status === "skipped" is synthesised from a null pitch_analysis on the wire.
export const parseAudioQualityCheckFromBackend = (
  raw: unknown
): AudioQualityBackendResult => {
  const parsed = audioQualityCheckWireSpec.parse(raw);
  const wirePitchAnalysis = parsed.pitch_analysis;

  return {
    instrumentRatio: parsed.instrument_ratio,
    reverbRatio: parsed.reverb_ratio,
    pitchAnalysis:
      wirePitchAnalysis === null ?
        { status: "skipped" }
      : {
          status: "ok",
          userRange: wirePitchAnalysis.user_range_midi,
          semitoneShift: wirePitchAnalysis.semitone_shift,
        },
  };
};
